import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";

const steps = [
  {
    step: "01",
    icon: "ri-file-edit-line",
    title: "Apply",
    text: "Fill in the short application form below with your farm and crop details.",
  },
  {
    step: "02",
    icon: "ri-phone-line",
    title: "We Talk",
    text: "Our team calls or visits to understand your farm, seasons and what you'd like to offer.",
  },
  {
    step: "03",
    icon: "ri-camera-line",
    title: "Set Up",
    text: "We help write your story, plan experiences and photograph your farm for the listing.",
  },
  {
    step: "04",
    icon: "ri-user-add-line",
    title: "Go Live",
    text: "Your farm is published and visitors start reaching out for visits and experiences.",
  },
  {
    step: "05",
    icon: "ri-hand-coin-line",
    title: "Host & Earn",
    text: "Welcome visitors, share your knowledge and receive prompt, transparent payments.",
  },
];

export default function PartnerSteps() {
  return (
    <section className="bg-secondary-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              How It Works
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            From Application to First Visitor
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
            Five simple steps. We hand-hold you through each one — no technical know-how needed on
            your side.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {steps.map((item, index) => (
            <Reveal key={item.step} delay={(index % 5) * 80} className="h-full">
              <div className="h-full bg-background-50 rounded-lg border border-secondary-200 p-6 flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-3xl text-accent-500 font-semibold">
                    {item.step}
                  </span>
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 font-semibold mt-5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-2">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}